module.exports = __webpack_public_path__ + "media/images/ok-779b9dc3928c2dbc304bcf6702bef6df.gif";